import type { ReactNode } from "react"
import { HeadContent, Scripts } from "@tanstack/react-router"
import StoreProvider from "../StoreProvider"
import { AuthWrapper } from "@/auth"
import { ErrorBoundary } from "@/monitoring"
import { UiProvider } from "@/ui"

type Props = {
  children: ReactNode
}

export default function Root({ children }: Props) {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body>
        <ErrorBoundary>
          <StoreProvider>
            <UiProvider>
              <AuthWrapper>{children}</AuthWrapper>
            </UiProvider>
          </StoreProvider>
        </ErrorBoundary>
        <Scripts />
      </body>
    </html>
  )
}
